import config from '../config';
import axios from 'axios';

const getVideoCallToken = (token, consultation_id, callBack) => {
  return (dispatch, getState) => {

    const requestURL = `${config.BASE_URL}/api/consultation/video/token/${consultation_id}`;
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }

    axios.get(requestURL, requestConfig).then((response) => {
      const data = response.data || {};
      const twilioToken = data.token || '';
      const identity = data.identity || '';
      if (callBack) {
        callBack(twilioToken, identity);
      }
    }).catch((error) => { console.log(error) });

  }
}

const updateVideoCallEstimateAmount = (token, consultationID, amount) => {
  return (dispatch, getState) => {

    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/consultation/${consultationID}`;

    const updatedConsultWithEstimate = {
      _id: consultationID,
      final_amount: amount,
    }

    axios.put(requestURL, JSON.stringify(updatedConsultWithEstimate), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {

      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}


const startCallNotification = (token, consultation_id) => {
  return dispatch => {

    const requestData = { consultation_id: consultation_id };
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/consultation/video/started`;

    axios.post(requestURL, JSON.stringify(requestData), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {

      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

const endCallNotification = (token, consultation_id) => {
  return dispatch => {

    const requestData = { consultation_id: consultation_id };
    const requestConfig = { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token } }
    const requestURL = `${config.BASE_URL}/api/consultation/end_call`;

    axios.post(requestURL, JSON.stringify(requestData), requestConfig).then((response) => {
      const data = response.data;
      if (data.success) {

      } else { console.log(data) }
    }).catch((error) => { console.log(error) });

  }
}

export default {
  endCallNotification,
  getVideoCallToken,
  startCallNotification,
  updateVideoCallEstimateAmount,
}
